import * as Keychain from 'react-native-keychain';

const ACCESS_SERVICE = 'ark-face-attendance-access-token';
const REFRESH_SERVICE = 'ark-face-attendance-refresh-token';
const ACCESS_ACCOUNT = 'access-token';
const REFRESH_ACCOUNT = 'refresh-token';

export async function saveAccessToken(accessToken: string): Promise<void> {
  if (!accessToken.trim()) {
    throw new Error('Cannot save an empty access token');
  }
  await Keychain.setGenericPassword(ACCESS_ACCOUNT, accessToken, {
    service: ACCESS_SERVICE,
  });
}

export async function saveRefreshToken(refreshToken: string): Promise<void> {
  if (!refreshToken.trim()) {
    throw new Error('Cannot save an empty refresh token');
  }
  await Keychain.setGenericPassword(REFRESH_ACCOUNT, refreshToken, {
    service: REFRESH_SERVICE,
  });
}

export async function saveTokens(input: {
  accessToken: string;
  refreshToken: string;
}): Promise<void> {
  await saveAccessToken(input.accessToken);
  await saveRefreshToken(input.refreshToken);
}

export async function getAccessToken(): Promise<string | null> {
  const credentials = await Keychain.getGenericPassword({ service: ACCESS_SERVICE });
  return credentials ? credentials.password : null;
}

export async function getRefreshToken(): Promise<string | null> {
  const credentials = await Keychain.getGenericPassword({ service: REFRESH_SERVICE });
  return credentials ? credentials.password : null;
}

export async function removeAccessToken(): Promise<void> {
  await Keychain.resetGenericPassword({ service: ACCESS_SERVICE });
}

export async function removeRefreshToken(): Promise<void> {
  await Keychain.resetGenericPassword({ service: REFRESH_SERVICE });
}

export async function clearTokens(): Promise<void> {
  await Promise.all([removeAccessToken(), removeRefreshToken()]);
}
